import ProductNamePrice from './ProductNamePrice'
export default ProductNamePrice
